import React from 'react';
import { BsLinkedin, BsFacebook, BsGithub } from 'react-icons/bs';

const RedSocial = () => {
  return (
    <div className='header__socials'>
      <a href='https://www.linkedin.com/in/bryan-smith-coronado-santi-387024233/' target='_blank' rel='noopener noreferrer'>
        <BsLinkedin />
      </a>
      <a href='https://www.facebook.com/profile.php?id=100072381273626' target='_blank' rel='noopener noreferrer'>
        <BsFacebook />
      </a>
      <a href='https://github.com/BryanCoronado' target='_blank' rel='noopener noreferrer'>
        <BsGithub />
      </a>
    </div>
  );
};

export default RedSocial;
